export default {
    getSearchResult(state) {
        return state.searchResults;
    },
    getSearchParams(state) {
        return state.searchParams;
    }
}